import React from 'react';

import scss from '../AssetPreviewModal.module.scss';

function ImagePreview({ image }) {
  return (
    <>
      <div className={scss.stage}>
        <img src={image.url} alt={image.label} className={scss.image} />
      </div>

      <dl className={scss.meta}>
        <dt>{image.label}</dt>
        <dd>
          {image.width} × {image.height} px
        </dd>
      </dl>
    </>
  );
}

export default ImagePreview;
